module.exports = __webpack_public_path__ + "static/media/insta-5-min.3bde4be8.png";